<template lang="pug">
.avex-coach-list
  avex-coaches-query
    template(slot-scope="coaches")
      coach-list(
        :coaches="coaches.data"
        @click="$emit('click', $event)")
</template>

<script>
import AvexCoachesQuery from '@/components/queries/AvexCoachesQuery'
import CoachList from '@/components/organisms/CoachList'

export default {
  components: {
    AvexCoachesQuery,
    CoachList,
  },
}
</script>
